import { useEffect } from "react";
import useExtractedSearchParam from "util/useExtractedSearchParam";

export const scrollToTodoContainerKey = "scroll_to_game";

export default function useScrollToTodoContainer() {
  const scrollToGameCardParam = useExtractedSearchParam(
    scrollToTodoContainerKey
  );

  useEffect(() => {
    if (!scrollToGameCardParam) {
      return;
    }

    const waitBeforeScrolling = 1000;

    setTimeout(() => {
      const element = document.getElementById(scrollToGameCardParam);

      if (element) {
        element.scrollIntoView({
          block: "center",
          behavior: "smooth",
          inline: "center",
        });
      }
    }, waitBeforeScrolling);
  }, [scrollToGameCardParam]);
}
